import axios from "axios";

const service = axios.create(Object.assign({}, { timeout: 10000 }));

service.interceptors.request.use(
  config => {
    config.headers["content-type"] = "application/json;charset=utf-8";
    return config;
  },
  error => {
    return Promise.reject(error.response);
  }
);

service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export { service };
